export default "__VITE_ASSET__DjbYyvxe__"